import { render, staticRenderFns } from "./LoggingTable.vue?vue&type=template&id=2c290342&scoped=true"
import script from "./LoggingTable.vue?vue&type=script&lang=js"
export * from "./LoggingTable.vue?vue&type=script&lang=js"
import style0 from "./LoggingTable.vue?vue&type=style&index=0&id=2c290342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c290342",
  null
  
)

export default component.exports